import React, { createContext, useContext, useEffect, useState } from 'react';
import searchExpandedTreeItems from './search_tree_items';
const TreeViewContext = createContext({});
const TreeViewProvider = (props) => {
    const { icons, selectedId, treeNodes, } = props;
    const [expandedItems, setExpandedItems] = useState([]);
    const defaultIcons = { collapseIcon: 'fas fa-caret-down', expandIcon: 'fas fa-caret-right' };
    useEffect(() => {
        if (selectedId) {
            const defaultExpandedItems = searchExpandedTreeItems(selectedId, treeNodes);
            setExpandedItems([...expandedItems, ...defaultExpandedItems]);
        }
    }, []);
    useEffect(() => {
        if (selectedId) {
            const defaultExpandedItems = searchExpandedTreeItems(selectedId, treeNodes);
            setExpandedItems([...expandedItems, ...defaultExpandedItems]);
        }
    }, [selectedId]);
    const toggleExpandedItem = (node) => {
        if (node.children && node.children.length > 0) {
            if (expandedItems.includes(node.id)) {
                setExpandedItems((expandedItems) => expandedItems.filter((item) => item !== node.id));
            }
            else {
                setExpandedItems(expandedItems => [...expandedItems, node.id]);
            }
        }
    };
    const value = {
        expandedItems,
        toggleExpandedItem,
        icons: Object.assign(Object.assign({}, defaultIcons), icons),
    };
    return React.createElement(TreeViewContext.Provider, Object.assign({ value: value }, props));
};
const useTreeView = () => {
    const context = useContext(TreeViewContext);
    if (!context)
        throw new Error('TreeViewContext must be used inside of a TreeViewProvider');
    return context;
};
export { TreeViewProvider, useTreeView, };
